// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get, post, del } from "./api_client";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function upload(organizationId?: string, path?: string): ApiResult<string> {
		const queryParams = [path !== undefined ? `path=${path}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return post<string>(`/api/file/${ organizationId }${query}`);
}

export async function uploadToPublic(path?: string): ApiResult<string> {
		const queryParams = [path !== undefined ? `path=${path}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return post<string>(`/api/file/public${query}`);
}

export async function list(organizationId?: string, path?: string): ApiResult<string[]> {
		const queryParams = [organizationId !== undefined ? `organizationId=${organizationId}` : undefined,
			path !== undefined ? `path=${path}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return get<string[]>(`/api/file/list${query}`);
}

export async function deleteFile(organizationId?: string, path?: string): ApiResult<undefined> {
		const queryParams = [organizationId !== undefined ? `organizationId=${organizationId}` : undefined,
			path !== undefined ? `path=${path}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return del(`/api/file/${query}`);
}

export async function getPublicUrl(pathAndFile?: string): ApiResult<string> {
		const queryParams = [pathAndFile !== undefined ? `pathAndFile=${pathAndFile}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return get<string>(`/api/file/public${query}`);
}
